/**
* SoundCommand.js
* Created on 10-5-2021
* @author Swen Meeuwes for &ranj
**/

import AbstractCommand from "../../../core/application/AbstractCommand";
import SoundEvent from "../event/SoundEvent";
import VideoPlayerDispenserHelper from '../../../core/video/VideoPlayerDispenserHelper';
import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";

export default class SoundCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SoundManager} soundManager 
     */
    constructor(dispatcher, soundManager) {
        super(dispatcher);

        this._soundManager = soundManager;
    }

    execute(evt) {
        let eventType = evt.type;

        switch (eventType) {
            case SoundEvent.MUTE:
                this._soundManager.setMute(true);
                this._setVideoPlayersMute(true);
                break;
            case SoundEvent.UNMUTE:
                this._soundManager.setMute(false);
                this._setVideoPlayersMute(false);
                break;
            default:
                console.warn('[SoundCommand] Event type ' + eventType + ' was ignored.');
                break;
        }
    }

    _setVideoPlayersMute(muted) {
        if (!VideoPlayerDispenserHelper.isInitialized()) {
            return;
        }

        let mainVideoPlayer = VideoPlayerDispenserHelper.getVideoPlayer(VideoPlayerDispenserHelper.videoPlayerIds.mainVideoPlayer);
        mainVideoPlayer.muted(muted);
    }
}